import React from 'react';
import { Link } from 'react-router-dom';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

export default class TrialExpireModal extends React.Component {
  renderNonEditorContent() {
    return (
      <p id="nonEditorContent">
        Enjoying MapPlug? Tell your account owner, {this.props.ownerName}, to
        set up billing so that you can keep using it.
      </p>
    );
  }

  renderEditorContent() {
    return (
      <p>
        Visit your{' '}
        <Link to="/account/settings" onClick={this.props.onAccountClick}>
          account settings
        </Link>{' '}
        to set up billing.
      </p>
    );
  }

  getExpirationString() {
    const { trialDaysRemaining, trialExpiration } = this.props;
    if (trialDaysRemaining === 0) {
      return 'today';
    }
    let endDate = trialExpiration.format('MMMM DD, YYYY');
    let dayOrDays = trialDaysRemaining === 1 ? 'day' : 'days';
    return `in just ${trialDaysRemaining} ${dayOrDays} on ${endDate}`;
  }

  render() {
    const actions = [
      <FlatButton
        label="Done"
        primary
        onClick={this.props.onRequestClose}
        disabled={false}
      />
    ];

    return (
      <Dialog
        autoScrollBodyContent
        actions={actions}
        open={true}
        contentStyle={{ maxWidth: 800 }}
      >
        <div style={{ padding: 16 }}>
          <div>
            <div style={{ marginBottom: 32 }}>
              <h2>Your Trial is Expiring Soon</h2>
              <p style={{ paddingTop: 16, paddingBottom: 16 }}>
                Thank you for using MapPlug! Your free trial ends{' '}
                {this.getExpirationString()}!
              </p>
              <p>If you need more time to try the system, let us know.</p>
              {this.props.accountEditPermission
                ? this.renderEditorContent()
                : this.renderNonEditorContent()}
            </div>
          </div>
        </div>
      </Dialog>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TrialExpireModal/index.jsx